import { Mountain, MapPin, Layers } from "lucide-react";
import Reveal, { Stagger, StaggerItem } from "@/components/motion/Reveal";

export default function CoalMining() {
  return (
    <section
      id="mining"
      data-testid="mining-section"
      className="relative bg-[#08080A] py-32 md:py-48 border-t border-white/8 overflow-hidden"
    >
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <Reveal className="md:col-span-6">
            <div className="overline mb-6">Our Businesses · II</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-neutral-50">
              Coal &amp; <span className="italic text-[#D4AF37]">Mining.</span>
            </h2>
            <div className="mt-3 font-display italic text-[#D4AF37] text-lg md:text-xl">
              Strategic mining operations in Jharkhand.
            </div>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-6 md:pt-6">
            <p className="text-neutral-400 text-base md:text-lg leading-relaxed">
              Rudra Empire operates in the coal mining sector in Jharkhand,
              representing the group&apos;s interests in India&apos;s strategic
              natural-resource sector. The vertical is managed with the same
              discipline of documentation, discretion and long time horizons
              that defines the House of Rudra.
            </p>
          </Reveal>
        </div>

        {/* Ownership + Region + Sector cards */}
        <Stagger className="grid grid-cols-1 md:grid-cols-3 gap-6" gap={0.12}>
          <StaggerItem>
            <div className="card-gold-hover bg-[#121215] p-8 h-full">
              <Layers strokeWidth={1} className="w-8 h-8 text-[#D4AF37] mb-6" />
              <div className="overline mb-3">Principal Ownership Interest</div>
              <div className="font-display text-5xl md:text-6xl text-neutral-50 leading-none">
                75<span className="text-[#D4AF37]">%</span>
              </div>
              <p className="mt-4 text-neutral-500 text-xs tracking-wider uppercase">
                Held by the Chairman
              </p>
            </div>
          </StaggerItem>
          <StaggerItem>
            <div className="card-gold-hover bg-[#121215] p-8 h-full">
              <Layers strokeWidth={1} className="w-8 h-8 text-neutral-500 mb-6" />
              <div className="overline mb-3">Partner Interest</div>
              <div className="font-display text-5xl md:text-6xl text-neutral-50 leading-none">
                25<span className="text-neutral-500">%</span>
              </div>
              <p className="mt-4 text-neutral-500 text-xs tracking-wider uppercase">
                Partner participation
              </p>
            </div>
          </StaggerItem>
          <StaggerItem>
            <div className="card-gold-hover bg-[#121215] p-8 h-full">
              <MapPin strokeWidth={1} className="w-8 h-8 text-[#D4AF37] mb-6" />
              <div className="overline mb-3">Operating Region</div>
              <div className="font-display text-4xl md:text-5xl text-neutral-50 leading-tight">
                Jharkhand
              </div>
              <p className="mt-4 text-neutral-500 text-xs tracking-wider uppercase">
                India
              </p>
            </div>
          </StaggerItem>
        </Stagger>

        {/* Distinction note */}
        <Reveal className="mt-12 border-l-2 border-[#D4AF37]/40 pl-6 max-w-3xl">
          <div className="flex items-start gap-4">
            <Mountain strokeWidth={1} className="w-5 h-5 text-[#D4AF37] mt-1 shrink-0" />
            <p className="text-neutral-400 text-sm leading-relaxed">
              The 75% principal ownership interest in the mining operation is
              personally held by <span className="text-neutral-100">Anurag Singh</span>.
              This interest is distinct from the land-acquisition operations of
              RUDRA EMPIRE and is disclosed here as part of the group&apos;s
              wider commercial footprint.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
